import TextCompressorTabs from './components/TextCompressorTabs';

export const CompressorTab = () => {
  return <TextCompressorTabs />;
};

export default CompressorTab;
